import wx from 'weixin-js-sdk'
// import logo from '@/assets/logo.png'

function jsonp (options) {
  let url = options.url
  let data = options.data

  let oBody = document.getElementsByTagName('body')[0]
  let oScript = document.createElement('script')

  let callbackName = 'cb' + (~~(Math.random() * 0xffffff)).toString(16)
  window[callbackName] = function (result) {
    options.success(result)
  }
  data[options.callback] = callbackName
  // oScript.setAttribute('src', url + '?' + format(data))
  oScript.setAttribute('src', url + '?' + 'callback' + '=' + callbackName + '&' + 'url' + '=' + encodeURIComponent(location.href))
  oBody.append(oScript)
}
// function format (data) {
//   let str = ''
//   for (var p in data) {
//     // str += encodeURIComponent(p) + '=' + encodeURIComponent(data[p]) + '&'
//     str += p + '=' + data[p] + '&'
//   }
//   return str.substr(0, str.length - 1)
// }

export default function share (vue) {
  // console.log(vue.$weixin)
  let wxShareConfig = {
    title: '一键下单，专业安心',
    imgUrl: 'http://' + location.hostname + location.pathname + 'static/image/logov1.png',
    // imgUrl: location.origin + '',
    desc: '大众出行，一键下单，首单立减14元，现在出发>>',
    link: location.origin + location.pathname
  }

  jsonp({
    url: 'https://tg-sh.letzgo.com.cn/dzcx_tg/wechatShare/getSignV2', // 接口的路径
    type: 'get',
    data: {
      url: encodeURIComponent(location.href) // 要获取微信签名的路径
    },
    callback: 'callback',
    success: function (data) {
      // console.log(data)
      wx.config({
        debug: false, // debug模式
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.sign,
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
      wx.ready(function () {
        wx.onMenuShareTimeline(wxShareConfig)
        wx.onMenuShareAppMessage(wxShareConfig)
        wx.onMenuShareQQ(wxShareConfig)
        wx.onMenuShareQZone(wxShareConfig)
      })
      // wx.
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/wxShare.js